export default "__VITE_ASSET__BebtyEzc__"